<template>
  <div class="bg-white px-3 index">
    <div class="add_tits" ref="titles">
      <el-form :inline="true" class="form-inlines">
        <el-form-item>
          <el-date-picker v-model="values" type="daterange" size="small" :clearable="false" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="search_day">搜索</el-button>
          <!-- <el-button type="primary" size="small" @click="submitTime(1)">昨</el-button>
                    <el-button type="primary" size="small" @click="submitTime(3)">3</el-button>
                    <el-button type="primary" size="small" @click="submitTime(7)">7</el-button>
                    <el-button type="primary" size="small" @click="submitTimeBy">本月</el-button>
                    <el-button type="primary" size="small" @click="submitTimeSy">上月</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="ibox-content">
      <el-table :data="tableData" v-loading="loading" border :height="Heighttab" ref="table">
        <el-table-column v-for="(item, ind) in header" :key="ind" :label="item.name" align="center">
          <el-table-column v-show="item.child.length > 0" v-for="iteme in item.child" :prop="iteme.key" :key="iteme.key"
            :label="iteme.name" align="center">
            <el-table-column v-show="iteme.child.length > 0" v-for="itemed in iteme.child" :prop="itemed.key"
              :key="itemed.key" :label="itemed.name" align="center">
            </el-table-column>
            <template slot-scope="{ row }" v-if="iteme.child.length < 1">
              {{ row[iteme.key] }}
              <el-button type="text" v-if="iteme.key == 'bj_salesman'" @click="adds(row)">添加业务员</el-button>
              <!-- <el-button type="text" v-if="iteme.key=='cz_jemx'" @click='details(row)'>明细</el-button> -->
            </template>
          </el-table-column>
          <template slot-scope="{ row }" v-if="item.child.length < 1">
            {{ row[item.key] }}
          </template>
        </el-table-column>
      </el-table>
      <div class="u-f u-ac u-jsb ft_mr">
        <div></div>
        <div>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="count">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="录入业务员" :visible.sync="dsdialogs" top="150px" width="40%" center class="dialogs">
      <el-divider></el-divider>
       <el-form label-width="100px">
        <el-form-item label="业务员">
         <el-select filterable v-model="yewuyuan" placeholder="请选择" style="max-width: 400px" size="small">
            <el-option v-for="item in yw_list" :key="item.id" :label="item.nickname" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dssubmit()" size="small" type="primary" :loading="subloading">提 交</el-button>
        <el-button @click="dsdialogs = false" size="small">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="明细" :visible.sync="mxdialogs" top="100px" width="60%" center class="dialogs">
      <el-divider></el-divider>
      <el-form :inline="true" class="form-inlines">
        <el-form-item>
          <el-date-picker v-model="valuesmx" type="daterange" size="small" :clearable="false" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="search_mx">搜索</el-button>
        </el-form-item>
      </el-form>
      <div class="dialog-ibox-content" v-loading="mxloading">
        <template>
          <el-table :data="tableDatamx" style="width: 100%" :height="Heighttab2">
            <el-table-column prop="grantee_name" label="被打赏人" width="180"></el-table-column>
            <el-table-column prop="pay_price" label="打赏金额" width="180"></el-table-column>
            <el-table-column prop="award_time" label="打赏日期"></el-table-column>
            <el-table-column prop="source_text" label="类型"></el-table-column>
          </el-table>
          <div class="u-f u-ac u-jsb ft_mr">
            <div></div>
            <div>
              <el-pagination @current-change="handleCurrentChangemx" :current-page="currentPagemx"
                layout="total, prev, pager, next, jumper" :total="countmx">
              </el-pagination>
            </div>
          </div>
        </template>
      </div>
      <el-divider></el-divider>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mxdialogs = false" size="small" type="primary">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  export default {
    data() {
      return {
        values: [],
        zdb_value1: "",
        zdb_value2: "",
        ydb_value1: "",
        ydb_value2: "",
        loading: false,
        header: [],
        tableData: [],
        Heighttab: null,
        Heighttab2: null,
        count: 0,
        currentPage: 1,
        pagesize: 15,
        ds_mon_value: "",
        dsdialogs: false,
        subloading: false,
        lr_data: {
          id: "",
          name: "",
          counts: "",
          month: "",
        },
        tableDatamx: [],
        mxdialogs: false,
        countmx: 0,
        currentPagemx: 1,
        mxloading: false,
        valuesmx: [],
        eid: "",
        yewuyuan: "",
        yw_list:[],
      };
    },
    computed: {
      ...mapState({
        user: (state) => state.user.user,
      }),
    },
    mounted() {
      let that = this;
      that.gettime();
      that.getheight();
      this.searchywUser()
    },
    methods: {
      searchywUser() {
        this.loading = true
        let url = `/admin/manager/1?limit=500&keyword=&role_id=35`;
        this.axios
          .get(url, {
            token: true,
          })
          .then((res) => {
            this.yw_list = res.data.data.list;
          })
          .catch((err) => {});
      },
      gettime() {
        this.submitTimeBy();
      },
      getheight() {
        let that = this;
        that.$nextTick(() => {
          var titles = that.$refs.titles.offsetHeight;
          that.Heighttab = window.innerHeight - titles - 200 + "px";
          that.Heighttab2 = window.innerHeight - titles - 375 + "px";
          window.onresize = () => {
            var titles = that.$refs.titles.offsetHeight;
            that.Heighttab = window.innerHeight - titles - 200 + "px";
            that.Heighttab2 = window.innerHeight - titles - 375 + "px";
          };
        });
      },

      search_day() {
        let that = this;
        that.loading = true;
        that.header = [];
        that.tableData = [];
        axios
          .post(
            "/admin/pc/report/DocBusinessReport", {
              start_time: that.values[0],
              end_time: that.values[1],
              page: this.currentPage,
              page_count: this.pagesize,
              type: 1
            }, {
              token: true,
            }
          )
          .then((response) => {
            that.loading = false;
            that.header = response.data.data.header;
            that.tableData = response.data.data.list;
            that.count = response.data.data.count;
            that.$nextTick(() => {
              that.$refs.table.doLayout();
            });
          })
          .catch((error) => {});
      },
      handleSizeChange(val) {
        let that = this;
        that.pagesize = val;
        that.search_day();
      },
      handleCurrentChange(val) {
        let that = this;
        that.currentPage = val;
        that.search_day();
      },
      search_week() {
        let that = this;
        var week1 = this.$refs.week1.displayValue;
        var week2 = this.$refs.week2.displayValue;
        that.header = [];
        that.tableData = [];
        if (week1 && week2) {
          that.loading = true;
          var w1 = week1.split("第 ")[1];
          w1 = w1.split(" 周")[0];
          var w2 = week2.split("第 ")[1];
          w2 = w2.split(" 周")[0];
          axios
            .post(
              "/admin/pc/report/DocBusinessReport", {
                start_time: that.zdb_value1,
                end_time: that.zdb_value2,
                time_type: "3",
              }, {
                token: true,
              }
            )
            .then((response) => {
              that.loading = false;
              that.header = response.data.data.header;
              that.tableData = response.data.data.list;
              that.$nextTick(() => {
                that.$refs.table.doLayout();
              });
            })
            .catch((error) => {});
        } else {
          this.$message({
            showClose: true,
            message: "请先选择第几周",
            type: "warning",
          });
        }
      },
      search_month() {
        let that = this;
        that.loading = true;
        that.header = [];
        that.tableData = [];
        if (this.ydb_value1 && this.ydb_value2) {
          axios
            .post(
              "/admin/pc/report/DocBusinessReport", {
                start_time: that.ydb_value1,
                end_time: that.ydb_value2,

                time_type: "2",
              }, {
                token: true,
              }
            )
            .then((response) => {
              that.loading = false;
              that.header = response.data.data.header;
              that.tableData = response.data.data.list;
              that.$nextTick(() => {
                that.$refs.table.doLayout();
              });
            })
            .catch((error) => {});
        } else {
          that.loading = false;
          this.$message({
            showClose: true,
            message: "请先选择月份",
            type: "warning",
          });
        }
      },
      adds(r) {
        this.lr_data.id = r.doc_id
        this.lr_data.name = r.name
        // this.lr_data.counts = r.yhbdsj_byxzyh
        // this.ds_mon_value = ''
        // var date = new Date();
        // var month = parseInt(date.getMonth() + 1);
        // this.lr_data.month = month
        this.dsdialogs = true;
      },
      dssubmit() {
        let user=this.yw_list.find(a=>{return a.id==this.yewuyuan})
        axios
          .post(
            "/admin/pc/report/createSalesman", {
              doc_id: this.lr_data.id,
              doctor_name: this.lr_data.name,
              salesman: user.username,
              salesman_id: user.id,
            }, {
              token: true,
            }
          )
          .then((res) => {
            this.subloading = false;
            if (res.data.code == 200) {
              this.$message.success("录入成功！");
              this.dsdialogs = false;
              this.search_day()
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((error) => {});
      },
      details(r) {
        this.mxdialogs = true;
        this.valuesmx = [];
        this.eid = r.doc_id;
        this.search_mx();
      },
      search_mx() {
        let that = this;
        this.mxloading = true;
        axios
          .post(
            "/admin/pc/CapitalDetails/detailList", {
              start_time: that.valuesmx[0],
              end_time: that.valuesmx[1],
              source: 4,
              user_id: this.eid,
              page: this.currentPagemx,
            }, {
              token: true,
            }
          )
          .then((res) => {
            this.mxloading = false;
            if (res.data.code == 200) {
              this.tableDatamx = res.data.data.list;
              this.countmx = res.data.data.count;
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((error) => {});
      },
      handleCurrentChangemx(val) {
        let that = this;
        that.currentPagemx = val;
        that.search_mx();
      },
      //获取n天前时间
      submitTime(n) {
        //开始时间
        var nowDate = new Date();
        let befDate = new Date(nowDate.getTime() - n * 24 * 3600 * 1000);
        let byear = befDate.getFullYear();
        let bmonth = befDate.getMonth() + 1;
        if (bmonth >= 1 && bmonth <= 9) {
          bmonth = "0" + bmonth;
        }
        let bday = befDate.getDate();
        if (bday >= 0 && bday <= 9) {
          bday = "0" + bday;
        }
        //截止时间
        let endDate = new Date(nowDate.getTime() - 1 * 24 * 3600 * 1000);
        let year = endDate.getFullYear();
        let month = endDate.getMonth() + 1;
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        let day = endDate.getDate();
        if (day >= 0 && day <= 9) {
          day = "0" + day;
        }

        //赋值
        let that = this;
        that.values = [
          byear + "-" + bmonth + "-" + bday,
          year + "-" + month + "-" + day,
        ];
        that.search_day();
      },
      //本月
      submitTimeBy() {
        let that = this;
        var date = new Date();
        var month = parseInt(date.getMonth() + 1);
        var day = date.getDate();
        if (month < 10) month = "0" + month;
        let yuechu = date.getFullYear() + "-" + month + "-" + "01";
        if (day == 1) {
          that.values = [yuechu, yuechu];
        } else {
          day = day - 1;
          if (day < 10) day = "0" + day;
          let yuedi = date.getFullYear() + "-" + month + "-" + day;
          that.values = [yuechu, yuedi];
        }
        that.search_day();
      },
      submitTimeSy() {
        let nowDate = new Date();
        let year = nowDate.getFullYear();
        let month = nowDate.getMonth();
        nowDate.setDate(0);
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        let day = nowDate.getDate();
        if (day >= 0 && day <= 9) {
          day = "0" + day;
        }
        let endTime = `${year}-${month}-${day}`;
        this.nowTime = endTime; // 当前的时间点
        let befDate = new Date(nowDate.getTime());
        let byear = befDate.getFullYear();
        let bmonth = befDate.getMonth() + 1;
        if (bmonth >= 1 && bmonth <= 9) {
          bmonth = "0" + bmonth;
        }
        let bday = befDate.getDate();
        if (bday >= 0 && bday <= 9) {
          bday = "0" + bday;
        }
        let startTime = `${byear}-${bmonth}-${bday}`;
        let that = this;
        that.values = [
          byear + "-" + bmonth + "-" + "01",
          byear + "-" + bmonth + "-" + day,
        ];
        that.search_day();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .widthfixs {
    width: 160px !important;
  }

  .red {
    color: red;
  }
</style>